import { useTheme, Theme } from '@/theme'
import { Button } from '@/ui/Button'
import { Popup } from '@/ui/Popup'
import { ModalTypes, useModal } from '@/components/Modal'
import { useGetUserInfo } from '@/modules/Auth'
import { getNameInitials } from '@/helpers/getNameInitials'
import { useCheckPermissions } from '@/permissions/useCheckPermissions'

import styles from './UserDetails.module.scss'

import UserIcon from '../assets/user.svg'
import SwitchUserIcon from '../assets/switch.svg'
import LogoutIcon from '../assets/logout.svg'

const appVersion = import.meta.env.VITE_VERSION || '1.0'

export const UserDetails = () => {
    const { data: userInfo } = useGetUserInfo()
    const { theme, setTheme } = useTheme()
    const { openModal } = useModal()
    const hasPermission = useCheckPermissions()

    const isAllowedToSwitchUser = hasPermission('user', 'switchUser')

    if (!userInfo) {
        return <></>
    }

    return (
        <Popup
            placement="bottom-end"
            triggerComponent={
                <Button size="small" className={styles.trigger}>
                    <UserIcon />{' '}
                    <span>{getNameInitials(userInfo.lastSessionDetails.authorName || userInfo.userDetails.name)}</span>
                </Button>
            }
        >
            <div className={styles.container}>
                <header className={styles.header}>
                    <div>
                        <span className={styles.text}>Creating content</span>
                        <div className={styles.user}>
                            <UserIcon />
                            <span className={styles.name}>{userInfo.lastSessionDetails.authorName}</span>
                        </div>
                    </div>
                    <span className={styles.description}>Logged in as {userInfo.userDetails.name}</span>
                </header>
                <section className={styles.actions}>
                    {isAllowedToSwitchUser && (
                        <Button variant="transparent" size="small" onClick={() => openModal(ModalTypes.switchUser)}>
                            <span className={styles.actionIcon}>
                                <SwitchUserIcon />
                            </span>
                            Switch author
                        </Button>
                    )}
                    <Button onClick={() => openModal(ModalTypes.logout)} variant="transparent" size="small">
                        <span className={styles.actionIcon}>
                            <LogoutIcon />
                        </span>
                        Log out
                    </Button>
                </section>
                <div className={styles.footer}>
                    <span className={styles.text}>Theme</span>
                    <div className={styles.footerActions}>
                        <Button
                            size={'small'}
                            variant={'outline'}
                            onClick={() => setTheme(Theme.dark)}
                            active={theme === Theme.dark}
                        >
                            Dark mode
                        </Button>

                        <Button
                            size={'small'}
                            variant={'outline'}
                            onClick={() => setTheme(Theme.light)}
                            active={theme === Theme.light}
                        >
                            Light mode
                        </Button>

                        <Button
                            size={'small'}
                            variant={'outline'}
                            onClick={() => setTheme(Theme.system)}
                            active={theme === Theme.system}
                        >
                            System
                        </Button>
                    </div>
                </div>
                <div className={styles.version}>Version {appVersion}</div>
            </div>
        </Popup>
    )
}
